import { html, LitElement, PropertyValues } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';

import { AppsGatewaySwitcherTags } from './apps-gateway-switcher.types.ts';
import { getGlobalStyleSheets } from '../../global-styles';
import { classMap } from 'lit/directives/class-map.js';
import { AtlIconTemplate } from '../icon/icon.component';
import { IconEnums } from '../icon';
import { ifDefined } from 'lit/directives/if-defined.js';

import AtlAppsGatewaySwitcherStyles from './apps-gateway-switcher.scss?inline';

@customElement(AppsGatewaySwitcherTags.AppsGatewaySwitcher)
export class AtlAppsGatewaySwitcher extends LitElement {
   static styles = [...getGlobalStyleSheets(), AtlAppsGatewaySwitcherStyles];

   @property({ type: String, attribute: 'app-name' })
   appName?: string;

   @property({ type: String, attribute: 'app-aria-label' })
   appAriaLabel?: string;

   @property({ type: Boolean, state: true })
   _isActive?: boolean;

   @query('.nav-link')
   private _dropDownButton?: HTMLElement;

   @query('.dropdown-menu')
   private _dropDownList?: HTMLElement;

   override connectedCallback() {
      super.connectedCallback();
      window.addEventListener('click', this._handleWindowClick);
   }

   override disconnectedCallback() {
      window.removeEventListener('click', this._handleWindowClick);
      super.disconnectedCallback();
   }

   private _handleWindowClick = (event: MouseEvent) => {
      if (!this._dropDownButton || !this._isActive) return;

      const path = event.composedPath();

      const isButtonClicked =
         this._dropDownButton && path.includes(this._dropDownButton);
      if (isButtonClicked) return;

      const isClickInside =
         this._dropDownList && path.includes(this._dropDownList);
      if (!isClickInside) {
         this._isActive = false;
      }
   };

   protected firstUpdated(changedProperties: PropertyValues): void {
      super.firstUpdated(changedProperties);
   }

   render() {
      const toggleClasses = {
         'dropdown-toggle': true,
         show: this._isActive === true,
      };

      const menuClasses = {
         'dropdown-menu': true,
         show: this._isActive === true,
      };

      return html`
         <div class="apps-gateway-switcher dropdown" type="button">
            <div
               class=${classMap(toggleClasses)}
               data-bs-toggle="dropdown"
               aria-haspopup="true"
               aria-expanded="${this._isActive ? 'true' : 'false'}"
               aria-label="${ifDefined(this.appAriaLabel ?? this.appName)}"
               role="button"
               tabindex="0"
            >
               <div
                  @click=${() => (this._isActive = !this._isActive)}
                  class="nav-link"
               >
                  <span class="app-title">${this.appName}</span>
                  ${AtlIconTemplate({
                     iconSource: IconEnums.IconSource.FontAwesome,
                     iconName: 'chevron-down',
                     iconClassNames: 'toggle-icon',
                     ariaHidden: true,
                  })}
               </div>
            </div>
            <div class=${classMap(menuClasses)}>
               <slot></slot>
            </div>
         </div>
      `;
   }
}
